import React from "react";

/**
 * Reusable TextArea component
 * 
 * @param {string} label - Textarea label
 * @param {string} value - Textarea value
 * @param {Function} onChange - Change handler
 * @param {string} placeholder - Placeholder text
 * @param {number} rows - Number of rows
 * @param {boolean} required - Is field required
 * @param {string} error - Error message
 * @param {string} className - Additional CSS classes
 * @param {object} props - Additional props
 */
export default function TextArea({
    label,
    value,
    onChange,
    placeholder = "",
    rows = 4,
    required = false,
    error,
    className = "",
    ...props
}) {
    return (
        <div className={className}>
            {label && (
                <label className="block text-sm font-semibold text-charcoal mb-2">
                    {label} {required && <span className="text-red-600">*</span>}
                </label>
            )}
            <textarea
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                rows={rows}
                className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-forest focus:border-transparent resize-vertical ${
                    error ? 'border-red-500' : 'border-gray-300'
                }`}
                {...props}
            />
            {error && (
                <p className="text-red-600 text-sm mt-1">{error}</p>
            )}
        </div>
    );
}
